import { Divider, Grid, TextField, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react'
import styles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import Required from '../../../../../utility/required'
import GlobalButton from '../../../../../utility/globalButton/button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { initialCreateWAFlowPayload } from './utils'
import agent from '../../../../../../services/api'
import { UserContext, UserContextPayload } from '../../../../../../context/userContext'
import { useGenericStore } from '../../../../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'

interface createWAFlowInterface {
    setFlagCreateWAFlow: React.Dispatch<React.SetStateAction<boolean>>
}

const CreateWAflowPopup = (props: createWAFlowInterface) => {
    const { setFlagCreateWAFlow } = props;
    const largeScreen = useMediaQuery('(max-width : 1600px) and (min-width : 0px)');
    const [createWAflowPayload, setCreateWAflowPayload] = useState(initialCreateWAFlowPayload);
    const [searchParams] = useSearchParams();
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const navigate = useNavigate();
    const id = searchParams.get('id');


    const handleCancelNewFlow = () => {
        setCreateWAflowPayload(initialCreateWAFlowPayload) 
        setFlagCreateWAFlow(false);
    }

    const handleCreateflow = async () => {
        let payload = createWAflowPayload;
        payload.meta_integration_whatsapp_id = id || ""
        // console.log(payload, "payload")
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await agent.createWAFlow.post(payload);
        if (res.status) {
            showSuccess("Rule-Based Chatbot Created Successfully!")
            setFlagCreateWAFlow(false);
            navigate(`/channels/viewintegration/whatsapp/flowDetails?id=${id}&flow_id=${res.data?.[0]?.whatsapp_flow_id}`)
        } else {
            // handleError(res); 
            if(res?.error?.code){
                handleError(res);
            } else {
                showError(res?.error ?? "Something Went Wrong")
            }
            setFlagCreateWAFlow(false)
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const isCreateWAflowDisabled = () => {
        if (createWAflowPayload?.whatsapp_flow_name == "" || createWAflowPayload?.whatsapp_flow_name?.trim() == "") {
            return true
        }
        return false
    }

    const handleOnChangeflowPayload = (field_name: string, value: string | number) => {
        setCreateWAflowPayload((prevstate) => ({ ...prevstate, [field_name]: value }))

    }

    return (
        <Grid container direction={"column"} gap={"20px"} padding={"0px 30px 30px 30px"} sx={{ zIndex: "1" }}>
            <Grid item sx={{ width: "100%" }} textAlign={"center"}>
                <span className={styles.popupTitleStyle}>Create New WhatsApp Flow</span>
            </Grid>

            <Grid item>
                <Divider className={styles.popupDividerStyle} />
            </Grid>

            <Grid item sx={{ width: "100%" }}>
                <Grid container direction={"column"} gap={"15px"}>
                    <Grid item sx={{ width: "100%" }}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>Flow Name <Required /></Grid>
                            <Grid item>
                                <TextField
                                    placeholder='Write a name for your flow...'
                                    className={styles.createGlobalTextField}
                                    value={createWAflowPayload.whatsapp_flow_name}
                                    onChange={(e) => handleOnChangeflowPayload("whatsapp_flow_name", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item sx={{ width: "100%" }}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>Flow Description</Grid>
                            <Grid item>
                                <TextField
                                    placeholder='Write a description for your flow...'
                                    className={styles.createGlobalTextField}
                                    value={createWAflowPayload.whatsapp_flow_description}
                                    onChange={(e) => handleOnChangeflowPayload("whatsapp_flow_description", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item sx={{ width: "100%" }} mt={2}>
                <Grid container direction={"row"} gap={2} justifyContent={"center"}>
                    <Grid item>
                        <GlobalButton 
                            buttonText={"Cancel"} 
                            className='borderedButtonStyle' 
                            sx={{ minWidth: "130px", fontSize: largeScreen ? "13px !important" : "" }} 
                            onClick={() => handleCancelNewFlow()} 
                        />
                    </Grid>
                    <Grid item>
                        <GlobalButton
                            buttonText={"Create"}
                            className='primaryButtonStyle'
                            sx={{ minWidth: "130px" }}
                            onClick={handleCreateflow}
                            disabled={isCreateWAflowDisabled()}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default CreateWAflowPopup
